/**
 * Prefer using this constant rather than calling "typeof" on "window" multiple times. Although "typeof" is fast on
 * primitive types and objects, it is particularly slow with global objects, like "window" or "globalThis" See
 * benchmark: https://measurethat.net/Benchmarks/Show/16972/0/typeof-globalthis-check
 */
export const IS_BROWSER_ENVIRONMENT = typeof window !== 'undefined';
//# sourceMappingURL=isBrowserEnvironment.js.map